import { ReactSVG } from 'react-svg';
import { Grid, useTheme } from '../../base';
import {
    LoginCard,
    LoginGrid,
    LoginWrapper,
    LogoWrapper,
} from './LoginCardLayout.styles';

interface Props {
    children: React.ReactNode;
}
const LoginCardLayout = ({ children }: Props) => {
    const theme = useTheme();
    return (
        <LoginWrapper>
            <LoginGrid container height={'100%'}>
                <Grid item xs={12} display={'flex'} justifyContent={'center'}>
                    <LoginCard>
                        <Grid container spacing={0} sx={{ height: 'auto' }}>
                            <Grid
                                item
                                xs={4}
                                sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    padding: 4,
                                    margin: -3,
                                    marginInlineEnd: 0,
                                }}
                            >
                                <LogoWrapper>
                                    <ReactSVG
                                        src={'/assets/logo.svg'}
                                        beforeInjection={(svg) => {
                                            svg.setAttribute(
                                                'style',
                                                'max-width: 100%'
                                            );
                                        }}
                                    />
                                </LogoWrapper>
                            </Grid>
                            <Grid
                                item
                                xs={8}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                {children}
                            </Grid>
                        </Grid>
                    </LoginCard>
                </Grid>
            </LoginGrid>
        </LoginWrapper>
    );
};

export default LoginCardLayout;
